exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".inviteTeachersModal .modal-body{text-align:left;padding-top:5px}.inviteTeachersModal .inviteRecipients,.inviteTeachersModal .modal-body p{margin-bottom:15px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/org/contests/invite_teachers_modal.scss
// module id = 1323
// module chunks = 0